// tslint:disable:no-any (autogenerated)
// tslint:disable:no-unsafe-any (autogenerated)
import { request as fetchRequest, TBodyParseFormat } from '../../services/request-manager/request';
import popupMessagesActions from '../../services/popup-notifications/popup-notifications-actions';

let request = fetchRequest;
const mocksRegex = /[?&](debug[%5B\[]){0,1}mocks([%5D\]]){0,1}=1/;
const allowMocks = mocksRegex.test(location.search);
if (NODE_ENV === 'development' && allowMocks) {
    // tslint:disable-next-line
    request = require('../../services/request-manager/legacy-request').default;
}

import settingsStore from '../../services/settings/settings-store';

interface IServerRequestErrorWithMessage {
    error?: string;
    message?: string;
    success?: boolean;
    reason?: string;
}

const reasonsToShowErrorMessage: ['passwordChanged', 'mailAddressChanged'] = ['passwordChanged', 'mailAddressChanged'];
const showErrorMessageByReason = (message: string): void => {
    popupMessagesActions.showMessage(message);
    setTimeout(() => {
        window.location.replace('/logout/index');
    }, 4000);
};

export class ServerRequestErrorWithMessage extends Error {
    public readonly serverResponse: IServerRequestErrorWithMessage;
    constructor(response: IServerRequestErrorWithMessage) {
        const message = response.message || (response.error && response.error.toString());
        super(message);
        this.serverResponse = response;
        this.name = 'ServerRequestErrorWithMessage';
        this.message = message;
        this.stack = (new Error() as any).stack;
    }

    public toString(): string {
        return this.message;
    }
}

// tslint:disable-next-line:max-classes-per-file (autogenerated)
export class ServerRequestErrorWithoutMessage extends Error {
    constructor(params: {}) {
        const message = settingsStore.getIntlMessage('js.server.error');
        super(message);
        this.message = message;
        this.stack = (new Error() as any).stack;
    }

    public toString(): string {
        return this.message;
    }
}

// tslint:disable-next-line:interface-over-type-literal (autogenerated)
type TOptions = {
    type?: string;
    contentType?: string;
    dataKey?: string;
    doNotUseCredentials?: boolean;
    bodyParseFormat?: TBodyParseFormat;
    jwt?: string;
};

// tslint:disable-next-line:max-classes-per-file (autogenerated)
class BaseRequest {
    private async sendRequest<T>(
        url: string,
        params?: any,
        options?: TOptions,
        doNotCheckSuccess?: boolean
    ): Promise<T> {
        // tslint:disable-next-line:no-parameter-reassignment (autogenerated)
        options = options || ({} as TOptions);
        const { doNotUseCredentials } = options;
        const promise = request(
            {
                url,
                type: options.type,
                contentType: options.contentType,
                data: params || null,
                xhrFields: {
                    withCredentials: !doNotUseCredentials
                },
                headers: options.jwt && {
                    Authorization: `Bearer ${options.jwt}`
                }
            },
            {
                doNotCheckSuccess
            },
            options.bodyParseFormat
        );

        return promise
            .catch(error => {
                if (error.reason && reasonsToShowErrorMessage.includes(error.reason)) {
                    showErrorMessageByReason(error.message);
                } else {
                    console.error(error, url, params, options, doNotCheckSuccess);
                    if (error.success === false) {
                        throw new ServerRequestErrorWithMessage(error);
                    }
                    throw new ServerRequestErrorWithoutMessage(error);
                }
            })
            .then(response => {
                if (doNotCheckSuccess) {
                    return response;
                }
                return response[options.dataKey || 'data'];
            });
    }

    protected async rawRequest<T>(url: string, params?: any, options?: TOptions): Promise<T> {
        return this.sendRequest<T>(url, params, options, true);
    }

    private static addIntstanceIdIfPost(params: any, options: TOptions): any {
        // tslint:disable-next-line:no-string-literal (autogenerated)
        if (options && 'type' in options && options['type'].toUpperCase() === 'POST') {
            // tslint:disable-next-line:no-string-literal (autogenerated)
            const instanceId = settingsStore.getEnvironment()['instanceId'];
            // tslint:disable-next-line:prefer-object-spread (autogenerated)
            return Object.assign({ instance: instanceId }, params);
        }

        return params;
    }

    protected async request<T>(url: string, params?: any, options?: TOptions): Promise<T> {
        // tslint:disable-next-line:no-parameter-reassignment (autogenerated)
        params = BaseRequest.addIntstanceIdIfPost(params, options);

        return this.sendRequest<T>(url, params, options, false);
    }
}

// tslint:disable-next-line:no-default-export (autogenerated)
export default BaseRequest;
